export const FORMAT_DATE = 'DD/MM/YYYY'

export const VALIDATE_BIRTHDAY = {
  min: new Date('01-01-1900'),
  max: new Date()
}

export const DATE_INVALID = '01/01/0001'

export const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const MONTH_HAS_31_DAY = [1, 3, 5, 7, 8, 10, 12]

export const DATE_EMPTY = '--/--/--'
